var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var SelectedTag = createReactClass({
    mixins: [PureRenderMixin],

    handleTagRemove: function(){
        this.props.onTagRemove(this.props.tag);
    },

    render: function(){
        var tag = this.props.tag;
        return (
            <li onClick={this.handleTagRemove}>{tag.name}<span className="ion-ios-close-empty"></span></li>
        );
    }
});

module.exports = SelectedTag;



// WEBPACK FOOTER //
// ./src/common/routes/message-center/components/layout/selectedTag.jsx